import React from "react";
import PropTypes from "prop-types";
import RSFormGroup from "reactstrap/lib/FormGroup";

import { gatherClasses } from "../../lib/utils";

const FormGroup = props => {
  const { footer, last, dataTestId, ...attr } = props;
  return (
    <RSFormGroup
      data-testid={dataTestId}
      className={gatherClasses(
        attr,
        footer ? "oui-text-right" : null,
        last ? "oui-mb-0" : null
      )}
      {...attr}
    >
      {attr.children}
    </RSFormGroup>
  );
};

FormGroup.propTypes = {
  children: PropTypes.node,
  // Applied the row class when true, does nothing when false
  row: PropTypes.bool,
  // Applied the form-check class when true, form-group when false
  check: PropTypes.bool,
  footer: PropTypes.bool,
  inline: PropTypes.bool,
  // Applied the disabled class when the check and disabled props are true, does nothing when false
  disabled: PropTypes.bool,
  last: PropTypes.bool,
  // Pass in a Component to override default element
  className: PropTypes.string,
  dataTestId: PropTypes.string
};

FormGroup.defaultProps = {
  row: false,
  check: false,
  inline: false,
  last: false,
  disabled: false,
  dataTestId: "orion-form-group"
};

FormGroup.displayName = "OrionFormGroup";

export default FormGroup;
